import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseEmailSignupVariables {
  email: string;
}

export interface UseEmailSignupData {
  email: string;
}

export function useEmailSignup() {
  return useMutation<
    UseEmailSignupData,
    AxiosError<UseEmailSignupData>,
    UseEmailSignupVariables
  >((variables) => {
    const data = variables;

    return axios
      .post<UseEmailSignupData>('/posht/ashena/signup/', data)
      .then((res) => res.data);
  });
}
